var data = {
  "body": "<rect x=\"32\" y=\"96\" width=\"448\" height=\"272\" rx=\"32.14\" ry=\"32.14\" fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"32\"/><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"32\" d=\"M128 416h256\" fill=\"currentColor\"/>",
  "width": 512,
  "height": 512
};
exports.__esModule = true;
exports.default = data;